module.exports = __webpack_public_path__ + "static/media/5.1f21db82.png";